import { render } from "./UserIcon.vue?vue&type=template&id=6e296ab3&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"

import "./UserIcon.vue?vue&type=style&index=0&id=6e296ab3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e296ab3"

export default script